class MultiSelect {
  constructor(el) {
    import('chosen-js').then(() => {
      $(el).chosen()
    })
  }
}

export default MultiSelect
